<template lang="pug">
  figure(:class="b()" @click="$emit('click')")
    img(:src="$cloudfrontURL(`/icoimages/${this.name}.svg`)")
</template>

<script>
  export default {
    name: 'rtc-icoimage',

    props: {
      name: { type: String, required: true },
    },
  };
</script>

<style lang="sass" scoped>
  .rtc-icoimage
    display: inline-block

    img
      display: block
      width: 100%
      height: 100%
</style>